import React from 'react';
import { connect } from 'react-redux';

import { selectLayoutType } from '~src/spacesPlatform/selectors/LayoutTypeSelector';
import { NavLocationSelectors } from '~src/spacesPlatform/selectors/NavigationStateSelectors';

import { AppState } from '../../../app/state/AppState';
import { MapStateToProps } from '../../../app/utils/ConnectUtils';
import { LeftNav, LeftNavProps } from './LeftNav';

const mapStateToProps: MapStateToProps<LeftNavProps> = (state: AppState) => ({
  isInVizViewerArea: NavLocationSelectors.inVizViewerArea(state),
  layoutType: selectLayoutType(state)
});

export const ConnectedLeftNav: React.ComponentClass =
  connect(mapStateToProps)(LeftNav);
